import PhoneInput from "react-phone-number-input";
import type { Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useTranslation } from "react-i18next";
import { PhoneFieldWrapper } from "./styles";

export interface PhoneNumberFieldProps {
  value?: string;
  /** Receives the E.164 value (e.g. +9665XXXXXXXX) or undefined when cleared. */
  onChange: (value: string | undefined) => void;
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
  /** Error message to display below the field. */
  error?: string;
  /** Shows the required asterisk on the label (validation is caller-owned). */
  required?: boolean;
  /** Default selected country (ISO-2, e.g. "SA"). */
  defaultCountry?: Country;
  disabled?: boolean;
  id?: string;
}

/**
 * Standard phone input with a country-code/flag selector (react-phone-number-input),
 * fully controlled so it drops into RHF (register/Controller) or plain useState
 * forms alike. Outputs E.164; convert per endpoint with formatPhoneForBackend.
 */
export function PhoneNumberField({
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  error,
  required,
  defaultCountry = "SA" as Country,
  disabled,
  id,
}: PhoneNumberFieldProps) {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <PhoneFieldWrapper
      $language={(language === "en" ? "en" : "ar") as "ar" | "en"}
      $isError={!!error}
    >
      {label != null && (
        <label htmlFor={id}>
          {label}
          {required && <span className="req">*</span>}
        </label>
      )}
      <PhoneInput
        id={id}
        international
        defaultCountry={defaultCountry}
        value={value}
        onChange={(v) => onChange(v || undefined)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
      />
      {error && (
        <div className="ErrorMessageStyle">
          <p>{error}</p>
        </div>
      )}
    </PhoneFieldWrapper>
  );
}

export default PhoneNumberField;
